import { useState } from "react"
import { ButtonV2 } from "../ui-components"
import { PlaidAccountAdd } from "./Plaid"

export function AccountBottomSheetAddAccountButton() {
  const [isStartingPlaidFlow, setIsStartingPlaidFlow] = useState(false)

  return (
    <PlaidAccountAdd
      onStart={() => setIsStartingPlaidFlow(true)}
      onExit={() => setIsStartingPlaidFlow(false)}
      onSuccess={() => setIsStartingPlaidFlow(false)}
      fallback={<ButtonV2 title="Add account" variant="blue2" loading disabled />}
    >
      <ButtonV2
        title="Add account"
        variant="blue2"
        loading={isStartingPlaidFlow}
        disabled
        accessibilityRole="none"
      />
    </PlaidAccountAdd>
  )
}
